import styled from 'styled-components';

const VersionPage = styled.div`
  display: flex;
  align-items: center;
  height: 100vh;
  justify-content: center;
  background-color: white;
`;

const Version = () => <VersionPage>Tifle Contact: Version 5.5.1 </VersionPage>;
export default Version;
